import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';
import * as _ from 'lodash';
import { MapsService } from 'src/app/services/maps.service';
import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AssetService } from 'src/app/services/asset.service';

@Component({
  selector: 'app-close-call-report',
  templateUrl: './close-call-report.component.html',
  styleUrls: ['./close-call-report.component.scss']
})

export class CloseCallReportComponent implements OnInit {
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  @Input('accident') accidentData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  previousIndex: any;
  closeCallForm: FormGroup
  files: any = [];
  newFiles: any = [];
  accidentId
  userId
  accidentDetails
  userDetails
  formDetails
  userName
  accidentLocation
  dateOfIncident
  extraDetails: any;
  loading: boolean;
  date: any;
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  user: any;
  isAdmin: boolean = false;
  isChecked: boolean = false;
  check: boolean = false;
  isEdit: boolean
  isMapEdit:boolean

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _mapsService: MapsService,
    private formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    public userDocumentService: UserDocumentService,
    private ngZone: NgZone
  ) { }


  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'));
    console.log("this.user", this.user);
    if (this.user.isAdmin) {
      console.log("this.isAdmin", this.user.isAdmin);
      this.isAdmin = true
    }

    this.loading = false;
    if (this.isEdit) { }
    else {
      this.createForm();
      // this.setCurrentLocation();
    }
  }




  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES datepicker", changes);
    if (changes.accidentData && changes.accidentData.currentValue) {
      this.accidentId = changes.accidentData.currentValue
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
    }
    if (changes.documentDetails && changes.documentDetails.currentValue) {
      let data = changes.documentDetails.currentValue
      this.accidentDetails = data.accidentDetails
      this.userDetails = data.userData

      if (data && data.details && data.details.details.closeCallForm) {
        this.formDetails = data.details.details.closeCallForm
        this.check = data.details.details.closeCallForm.checkbox
        this.extraDetails = data.details
        this.files = data.details.files
        this.isEdit = true

        let locationData = data.details.details.closeCallForm


        this.latitude = (locationData && locationData.location) ? locationData.location.coords.lat : ''
        console.log("here is the latitude", this.latitude)
        this.longitude = (locationData && locationData.location) ? locationData.location.coords.lng : ''
        this.address = (locationData && locationData.location) ? locationData.location.address : ''

        // this.latitude = data.details.details.closeCallForm.location.coords.lat
        // console.log("here is the latitude", this.latitude)
        // this.longitude = data.details.details.closeCallForm.location.coords.lng
        // this.address = data.details.details.closeCallForm.location.address
        this.createForm(this.formDetails)
        this.isMapEdit=true

      } else {
        
        this.isMapEdit=false
        this.isEdit = false
        if (this.userDetails && this.userDetails._id && this.userDetails._id.user) {
          console.log("this user details", this.userDetails);

          this.userName = this.userDetails._id.user.name
        } else {
          this.userName = this.userDetails.user.name
        }
        this.accidentLocation = this.accidentDetails.location
        // this.date = this.accidentDetails.date

        this.createForm()
        // this.closeCallForm.patchValue({
        //   date: this.date
        // })
      }
    }


  }


  // FORM GROUP

  createForm(data?) {
    console.log("data", data)
    this.closeCallForm = this.formBuilder.group({
      refNo: new FormControl((data && data.refNo) ? data.refNo : ''),
      name: new FormControl((data && data.name) ? data.name : ''),
      date: new FormControl((data && data.date) ? data.date : ''),
      checkbox: new FormControl((data && data.checkbox) ? data.checkbox : false),
      select: new FormControl((data && data.select) ? data.select : ''),
      description: new FormControl((data && data.description) ? data.description : ''),
      identify: new FormControl((data && data.identify) ? data.identify : ''),
      action: new FormControl((data && data.action) ? data.action : ''),
      feedback: new FormControl((data && data.feedback) ? data.feedback : ''),
    })
    if (this.isAdmin) {
      this.closeCallForm.get('action').enable()
      this.closeCallForm.get('feedback').enable()
    }
    else {
      this.closeCallForm.get('action').disable()
      this.closeCallForm.get('feedback').disable()
    }


    if (this.isEdit && this.check)
      this.closeCallForm.get('name').disable()
    else if (this.isChecked)
      this.closeCallForm.get('name').disable()
    else
      this.closeCallForm.get('name').enable()

  }


  // UTILITY

  checkName(event) {
    console.log(event.checked); //true or false
    if (event.checked)
      this.isChecked = true
    else
      this.isChecked = false

    if (this.isChecked)
      this.closeCallForm.get('name').disable()
    else
      this.closeCallForm.get('name').enable()
  }

  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);
    if (formControl == 'date') {
      this.closeCallForm.patchValue({ date: value })
    }
  }

  // mapReady() {
  //   this._mapsService.getCurrentAddress(this.latitude, this.longitude).subscribe((data)=>{
  //     console.log("hello here is address ...",data)
  //     this.address = data.address
  //   },(error)=>{
  //     console.log ("hello here is the ...",error)
  //   })
  // //  console.log("hello here is address ...",address)
  // }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }


  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
      this.latitude= mapCurrentValue.latitude
      this.longitude = mapCurrentValue.longitude
      this.address = mapCurrentValue.address
  }

  
  // API CALL

  save() {
    let param = {
    }
    console.log('this.closeCallForm.value---->', this.closeCallForm.value);

    if (this.isEdit) {
      let obj = {
        metaObj: {
          title: 'closeCallForm',
        },
        documentId: this.accidentId,
        userId: this.userId,
        onModel: 'accident',
        documentMetaId: this.extraDetails.documentMetaId,
        userDocumentId: this.extraDetails._id,
        files: this.files,
        newFiles: this.newFiles,
        details: {}
      }
      this.closeCallForm.value['location'] = {
        coords: { lat: this.latitude, lng: this.longitude },
        address: this.address
      }

      let details = {
        closeCallForm: this.closeCallForm.value
      }
      obj['details'] = details

      this.userDocumentService.updateUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
        this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })


    } else {
      let obj = {
        metaObj: {
          title: 'closeCallForm',
        },
        documentId: this.accidentId,
        userId: this.userId,
        onModel: 'accident',
        files: this.files,
        // documentId: this.planFormDetails._id,
        details: {}
      }
      this.closeCallForm.value['location'] = {
        coords: { lat: this.latitude, lng: this.longitude },
        address: this.address
      }

      let details = {
        closeCallForm: this.closeCallForm.value
      }

      obj['details'] = details
      this.userDocumentService.addUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
        this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    let param = {
    }
    param['accidentId'] = this.accidentId
    if (this.isAdmin) {
      this.router.navigate(['/accident/single-accident'], { queryParams: param })
    }
    else {
      this.router.navigate(['/accident'])
    }
  }

}